export const areObjectsEqual = (obj1: any, obj2: any): boolean => {

    const keys1 = Object.keys(obj1);
    const keys2 = Object.keys(obj2);

    if (keys1.length !== keys2.length) {
        return false;
    }

    for (let key of keys1) {
        if (
            Array.isArray(obj1[key]) &&
            Array.isArray(obj2[key]) &&
            obj1[key].length === 0 &&
            obj2[key].length === 0
        ) {
            continue;
        }
        if (obj1[key] !== obj2[key]) {
            return false;
        }
    }
    return true;
};